'use strict'

import SidePanel from '@design/objects/sidePanel/twig/assets/index'

import ElementPropertiesManager from 'assets/core/js/module/elementPropertiesManager'

import initSearchFiltersSidePanel from './side-panels/searchFilters'

export default function (): void {
  initSearchFiltersSidePanel()

  document.body.addEventListener('close-all-modals', () => {
    document
      .querySelectorAll<HTMLElement>('.accommodation__side-panel, .accommodation__pitch-side-panel, .search-filters__side-panel')
      .forEach((el) => {
        ElementPropertiesManager.getProperty<SidePanel>(el, 'sidePanel')?.close()
      })
  })
}
